export default __webpack_public_path__ + "static/media/certlayout_mumbai.98251bd1.png";